<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" )
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Action
            input(type="text", v-model="body.action", placeholder="Route name or route path on the app")
          label Title
            input(type="text", v-model="body.title" )
        .column
          label Slug
            input(type="text", v-model="body.slug")
          label Button label
            input(type="text", v-model="body.button_labels")

      .row.column
        label Content
        Editor( v-model="body.content")
      ActionButton(slot="footer" :action="save") Save


</template>

<script>
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import ActionButton from '../../components/structure/ui/ActionButton'
import {mapState} from "vuex";
import collect from "collect.js";
import Editor from "../../components/structure/ui/Editor.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";
import {EventBus} from "../../eventBus";

export default {
  name: 'PageReveal',
  components: {Editor, ActionButton, ModalReveal},
  data() {
    return {
      langs: [],
      body: {
        title: null,
        content: "",
        button_labels: null,
        action: "",
        slug: ""
      }
    }
  },
  created() {

  },
  methods: {
    save() {
      return KeplerBackofficeSdk.pages.make(this.body, () => {
        MaggieHelper.notification('page', 'page created')
        EventBus.$emit('reload-list')
        this.$refs[this.componentId].close()
      })
    }
  },
  computed: {
    componentId() {
      return `pageReveal-${this._uid}`
    },
    ...mapState({
      configuration: state => state.configuration,
    })
  },
  props: {
    item: {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreatePageReveal.vue?738b832e